<template>
  <div class="ss-g" :class="ctl.isPhone ? 'ss-g1' : 'ss-g2 ss-g2--eq'">
    <div class="ss-gm">
      <set-card id="mreze" :title="$t('settings_shell.links.social')">
        <div v-for="row in social" :key="row.path" class="ss-lrow">
          <span class="ss-lrow__i"><v-icon size="20">{{ row.icon }}</v-icon></span>
          <set-field :path="row.path" :label="row.label" :placeholder="row.placeholder" />
          <a v-if="openable(row.path)" class="ui-btn ui-btn--sm ui-btn--ghost" :href="ctl.val(row.path)" target="_blank" rel="noopener noreferrer" :aria-label="$t('settings_shell.links.open_named', { name: row.label })">
            <v-icon size="16">mdi-open-in-new</v-icon>
          </a>
          <button v-else type="button" class="ui-btn ui-btn--sm ui-btn--ghost" disabled :aria-label="$t('settings_shell.links.open_named', { name: row.label })">
            <v-icon size="16">mdi-open-in-new</v-icon>
          </button>
        </div>
      </set-card>
    </div>
    <div class="ss-gm">
      <set-card id="app" :title="$t('settings_shell.links.apps')">
        <div v-for="row in apps" :key="row.path" class="ss-lrow">
          <span class="ss-lrow__i"><v-icon size="20">{{ row.icon }}</v-icon></span>
          <set-field :path="row.path" :label="row.label" placeholder="https://" />
          <a v-if="openable(row.path)" class="ui-btn ui-btn--sm ui-btn--ghost" :href="ctl.val(row.path)" target="_blank" rel="noopener noreferrer" :aria-label="$t('settings_shell.links.open_named', { name: row.label })">
            <v-icon size="16">mdi-open-in-new</v-icon>
          </a>
          <button v-else type="button" class="ui-btn ui-btn--sm ui-btn--ghost" disabled :aria-label="$t('settings_shell.links.open_named', { name: row.label })">
            <v-icon size="16">mdi-open-in-new</v-icon>
          </button>
        </div>
      </set-card>
    </div>
  </div>
</template>

<script>
import { okUrl } from "../settingsLogic";
import SetCard from "../parts/SetCard.vue";
import SetField from "../parts/SetField.vue";

/** Osnovno › Linkovi: društvene mreže, prodavnice aplikacija i web aplikacija. */
export default {
  name: "ScreenLinks",
  components: { SetCard, SetField },
  inject: { ctl: "settingsCtl" },
  computed: {
    social() {
      return [
        { path: "facebook", label: "Facebook", icon: "mdi-facebook", placeholder: "https://facebook.com/…" },
        { path: "instagram", label: "Instagram", icon: "mdi-instagram", placeholder: "https://instagram.com/…" },
        { path: "twitter", label: "Twitter", icon: "mdi-twitter", placeholder: "https://twitter.com/…" },
        { path: "linkedin", label: "Linkedin", icon: "mdi-linkedin", placeholder: "https://linkedin.com/…" },
      ];
    },
    apps() {
      return [
        { path: "google", label: "Google Play", icon: "mdi-google-play" },
        { path: "apple", label: "Apple Store", icon: "mdi-apple" },
        { path: "huawei", label: "Huawei Store", icon: "mdi-cellphone" },
        { path: "webapp", label: this.$t("web_application"), icon: "mdi-web" },
      ];
    },
  },
  methods: {
    openable(path) {
      const value = this.ctl.val(path);
      return Boolean(value) && okUrl(value);
    },
  },
};
</script>
